import React from 'react';
import './blog-post.css';
import './blog-slides.css';
import activity from './pictures/y2kActivity.jpeg';
import attendees from './pictures/y2kAttendees.jpeg';
import presentation from './pictures/y2kPresentation.jpeg';
import snacks from './pictures/y2kSnacks.jpeg';
import winner from './pictures/y2kWinner.jpeg';

const Y2KNight = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Winter MM1: Y2K Night</h2>
                    <p className="site-post-meta">January 21, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you for joining us for our first Member Meeting of the quarter at our Y2K Night event! We hope you guys had a great time with lots of snacks and drinks, and learned a lot with an AMAZING presentation from our guest speakers: Juna and AJ!!
                    <br></br>
                    <br></br>
                    We definitely learned so much from them, and they were kind enough to share their presentation, which you can view here: https://www.canva.com/design/DAG-5_MVIlg/nlZ0pQcTzZcn-Lm1vs6NPw/edit! Thank you so much to everyone who came to the event and a special thank you to Juna and AJ for making the time to make an amazing presentation and spend the evening with us!
                    <br></br>
                    <br></br>
                    </p>
                    <img src={presentation} alt="Juna and AJ (our guest speakers) presenting."/>
                    <img src={activity} alt="Attendees working on activity"/>
                    <img src={winner} alt="The winner of our activity, chosen by Juna and AJ"/>
                    <img src={attendees} alt="Attendees working on activity"/>
                    <img src={snacks} alt="Attendees working on activity"/>

                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Y2KNight;
